(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider'];

    function stateConfig($stateProvider, $stickyStateProvider ) {
        $stateProvider
            .state('shipment', {
                parent: 'app',
                url: '/shipment',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_JPN'],
                    pageTitle: 'ccsTrApp.shipment.home.title',
                    title: 'Shipments'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/shipment/shipments.html',
                        controller: 'ShipmentController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('shipmentStatus');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('shipment.all', {
                parent: 'app',
                url: '/shipment/all',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_JPN','ROLE_AGENT'],
                    pageTitle: 'ccsTrApp.shipment.titleStatus.all',
                    title: 'All'
                },
                views: {
                    'shipment-all@': {
                        templateUrl: 'app/entities/shipment/shipments.html',
                        controller: 'ShipmentController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function() {
                        return {};
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('shipmentStatus');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('freight-payment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('shipment.shipment-detail', {
                parent: 'app',
                url: '/shipment/detail/{id}',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_JPN','ROLE_AGENT'],
                    pageTitle: 'ccsTrApp.shipment.detail.title',
                    title: 'Detail'
                },
                views: {
                    'shipment-detail@': {
                        templateUrl: 'app/entities/shipment/shipment-detail.html',
                        controller: 'ShipmentDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('shipmentStatus');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('freight-payment');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', '$state', 'ShipmentDTOService', function($stateParams, $state, ShipmentDTOService) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return ShipmentDTOService.get({id : paramId}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'shipment',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('shipment.new', {
                parent: 'app',
                url: '/shipment/new?fpId',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.shipment.new',
                    title: 'New'
                },
                views: {
                    'shipment-new@': {
                        controller: 'ShipmentDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/shipment/shipment-dialog.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('compType');
                        $translatePartialLoader.addPart('location');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('attachment');
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('freight-payment');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: null,
                            modifiedOn: new Date(),
                            modifiedBy: null,
                            siNum: null,
                            siDate: null,
                            shipmentMonth: null,
                            status: "DRAFT",
                            originEtd: null,
                            destEta: null,
                            cutoff: null,
                            shipmentCompany: null,
                            shipmentVessel: null,
                            shipmentVoyage: null,
                            freightPaymentDate: null,
                            freightInvoiceAmount: null,
                            freightInvoiceCurrency: "USD",
                            freightInvoiceAmountDisplay: null,
                            blNumber: null,
                            blDate: null,
                            blFrom: null,
                            blTo: null,
                            quantity: 0,
                            quantityContractA: 0,
                            quantityContractB: 0,
                            quantityContractC: 0,
                            quantityContractD: 0,
                            quantityContractE: 0,
                            quantitySaleContract: 0,
                            qtyUnitType: "BALES",
                            qtyBales: 0,
                            qtyBalesContractA: 0,
                            qtyBalesContractB: 0,
                            qtyBalesContractC: 0,
                            qtyBalesContractD: 0,
                            qtyBalesContractE: 0,
                            qtyBalesSaleContract: 0,
                            qtyMts: 0,
                            qtyMtsContractA: 0,
                            qtyMtsContractB: 0,
                            qtyMtsContractC: 0,
                            qtyMtsContractD: 0,
                            qtyMtsContractE: 0,
                            qtyMtsSaleContract: 0,
                            qtyLbs: 0,
                            qtyLbsContractA: 0,
                            qtyLbsContractB: 0,
                            qtyLbsContractC: 0,
                            qtyLbsContractD: 0,
                            qtyLbsContractE: 0,
                            qtyLbsSaleContract: 0,
                            qtyKgs: 0,
                            qtyKgsContractA: 0,
                            qtyKgsContractB: 0,
                            qtyKgsContractC: 0,
                            qtyKgsContractD: 0,
                            qtyKgsContractE: 0,
                            qtyKgsSaleContract: 0,
                            qtyDisplay: null,
                            qtyDisplayContractA: null,
                            qtyDisplayContractB: null,
                            qtyDisplayContractC: null,
                            qtyDisplayContractD: null,
                            qtyDisplayContractE: null,
                            qtyDisplaySaleContract: null,
                            lcNumber: null,
                            lcBankRef: null,
                            lcExpiry: null,
                            lcLatestShipment: null,
                            controller: null,
                            specialInstructions: null,
                            id: null,
                            goodsDescription: null,
                            wtBasis: null,
                            wtBasisDisplay: null,
                            paymentTerms: null,
                            paymentTermsDisplay: null,
                            incoTerms: null,
                            incoTermsDisplay: null,
                            incoTermsNContract: null,
                            incoTermsNContractDisplay: null
                        };
                    }
                }
            })
            .state('shipment.edit', {
                parent: 'app',
                url: '/shipment/{id}/edit',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.shipment.edit',
                    title: 'Edit'
                },
                views: {
                    'shipment-edit@': {
                        controller: 'ShipmentDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/shipment/shipment-dialog.html'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Shipment', function( $stateParams, Shipment ) {
                        return Shipment.get( {id: $stateParams.id } ).$promise;
                    }],
                    entityAudit: ['$stateParams', 'ShipmentAudit', function( $stateParams, ShipmentAudit ) {
                        return ShipmentAudit.get( { id: $stateParams.id } ).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('compType');
                        $translatePartialLoader.addPart('location');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('attachment');
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('freight-payment');
                        return $translate.refresh();
                    }]
                }
            })
            .state('shipment.edit-agent', {
                parent: 'app',
                url: '/shipment/{id}/edit-agent',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_AGENT'],
                    pageTitle: 'ccsTrApp.shipment.edit',
                    title: 'Edit'
                },
                views: {
                    'shipment-edit-agent@' : {
                        controller: 'ShipmentDialogAgentController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/shipment/shipment-dialog-agent.html'
                    }
                },
                resolve: {
                    entity: ['$stateParams','Shipment', function($stateParams, Shipment) {
                        return Shipment.get({id:$stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('compType');
                        $translatePartialLoader.addPart('location');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('attachment');
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('freight-payment');
                        return $translate.refresh();
                    }]
                }
            })
            .state('shipment.delete', {
                parent: 'app',
                url: '/shipment/{id}/delete',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/shipment/shipment-delete-dialog.html',
                        controller: 'ShipmentDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Shipment', function(Shipment) {
                                return Shipment.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('shipment', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            }).state('shipment.report', {
                parent: 'app',
                url: '/shipment/report',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'Report',
                    title: 'Report'
                },
                views: {
                    'shipment-report@': {
                        templateUrl: 'app/entities/shipment/shipments-report.html',
                        controller: 'ShipmentReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('shipmentStatus');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });

        $stickyStateProvider.enableDebug( true );
    }
})();
